import Select from './select'
import UserSearch from './user-search'

export default {
  Select,
  UserSearch,
}
